import { Permission, GlobalRole } from "../types/index.js";

export const APP_NAME = "K-UCAP";
export const APP_VERSION = "0.1.0";
export const APP_FULL_NAME =
  "Korea Unmanned System Conformance Assessment Platform";
export const FIREBASE_FUNCTIONS_REGION = "asia-northeast3";

export const MESSAGE_DICTIONARY_VERSION = "0.1.0-poc";

export const DEFAULT_VEHICLE_LAT = 37.389;
export const DEFAULT_VEHICLE_LON = 126.647;
export const DEFAULT_VEHICLE_ALT = 1200;

export const MESSAGE_LOG_MAX = 100;

export const DISCLAMER_TEXT =
  "K-UCAP | Integrated Message Simulation & Assessment Platform";

export const DEFAULT_ENVIRONMENT = "development";

export const GLOBAL_ROLE_PERMISSIONS: Record<GlobalRole, Permission[]> = {
  [GlobalRole.ADMIN]: Object.values(Permission),
  [GlobalRole.OPERATOR]: [
    Permission.PROJECT_VIEW,
    Permission.MESSAGE_DEFINITION_VIEW,
    Permission.MESSAGE_GENERATE,
    Permission.MESSAGE_ANALYZE,
    Permission.SCENARIO_VIEW,
    Permission.SCENARIO_MANAGE,
    Permission.SCENARIO_RUN,
    Permission.GIS_VIEW,
    Permission.MESSAGE_EVENT_VIEW,
    Permission.MESSAGE_EVENT_CREATE,
    Permission.REPORT_VIEW,
    Permission.REPORT_CREATE,
    Permission.SETTINGS_VIEW,
    Permission.INTEGRATION_VIEW,
    Permission.INTEGRATION_MANAGE,
  ],
  [GlobalRole.VIEWER]: [
    Permission.PROJECT_VIEW,
    Permission.MESSAGE_DEFINITION_VIEW,
    Permission.MESSAGE_ANALYZE,
    Permission.SCENARIO_VIEW,
    Permission.GIS_VIEW,
    Permission.MESSAGE_EVENT_VIEW,
    Permission.REPORT_VIEW,
    Permission.SETTINGS_VIEW,
    Permission.INTEGRATION_VIEW,
  ],
  [GlobalRole.GUEST]: [
    Permission.PROJECT_VIEW,
    Permission.MESSAGE_DEFINITION_VIEW,
    Permission.SCENARIO_VIEW,
    Permission.GIS_VIEW,
    Permission.MESSAGE_EVENT_VIEW,
    Permission.DEMO_INTERACT,
  ],
};
